import { Environment } from './environment.tpl';

enum KnownChannelIds {
  Durham = 'ZwXfz14MIq4cgXvXGRFn',
  Edinburgh = '48s70uFMw7A6zwwBBrRz',
  Kings = 'L89uyoqCzuphtWLrl9UY',
  Manchester = 'BpKUGfqLxV4qwupF10kd',
  Nottingham = 'OFTRJ6TSt76A1iiC6F2J',
  Swansea = 'hAnUZHT3HsnN1DLTPlHo',
  Oxford = 'BpMtUaKqTOmMRuNGuXdV',
  TeamSurrey = 'UnELknoy3nrYa265qkxg',
}

export const environment: Environment = {
  joymo: {
    authUrl: 'https://auth.joymo.uk',
    // TODO: set bucs support email when available.
    defaultSupportEmail: '',
  },
  firebase: {
    apiKey: 'AIzaSyDBBjFXmgw_z1mWLS8a-gpAQXPXoxUO_qQ',
    authDomain: 'bucs-deployment-prod.firebaseapp.com',
    projectId: 'bucs-deployment-prod',
    storageBucket: 'bucs-deployment-prod.appspot.com',
    messagingSenderId: '875381229713',
    appId: '1:875381229713:web:ef631db8916b690d975730',
    measurementId: 'G-EL45WMPW1W',
    locationId: 'europe-west2',
  },
  production: true,
  emulator: false,
  behavior: {
    defaultIcon: 'usm',
    betaDomains: [],
    cacheMaxAge: 600,
    defaultDomain: 'app.joymo.uk',
    domainAliases: {},
    emulateDomain: null,
    redirectToCanonicalUrl: true,
    defaultTheme: {
      accentColor: '#C4001A',
      backgroundColor: '#FFFFFF',
      themeStyle: 'rounded',
    },
    testFeatures: {
      channelsWithVideoFeedback: [],
      favicons: {
        default: 'FAVICON_NOT_SET',
        [KnownChannelIds.Edinburgh]: 'assets/favicons/edinburgh.png',
        [KnownChannelIds.Durham]: 'assets/favicons/durhamuniversity.png',
        [KnownChannelIds.Kings]: 'assets/favicons/kings.png',
        [KnownChannelIds.Manchester]:
          'assets/favicons/universityofmanchester.png',
        [KnownChannelIds.Nottingham]: 'assets/favicons/nottingham.png',
        [KnownChannelIds.Swansea]: 'assets/favicons/swansea.png',
        [KnownChannelIds.Oxford]: 'assets/favicons/oxford.png',
        [KnownChannelIds.TeamSurrey]: 'assets/favicons/teamsurrey.png',
      },
    },
  },
  sentry: {
    browser:
      'https://2a51cd4b882941b9a4227651e030fd84@o4505188070326272.ingest.sentry.io/4505249443414016',
  },
  google: {
    analytics: {
      gtmId: 'GTM-NKRZL4R',
    },
  },
  enableRouterTracing: false,
  // TODO: Update with VideoAnalytics config for BUCS
  videoAnalytics: {
    accountCode: 'joymo',
    enabled: true,
    debug: [],
    options: {
      'content.customDimension.1': 'USM',
    },
  },
};
